import { selectedSensorIconLabelLayer, selectedSensorIconLayer } from '@components/map/layers/sensors/sensor.layer';
import {
  expiredTargetTrajectory,
  selectedTargetBlinkingLayer,
  selectedTargetLayer,
  targetCrossLayer,
} from '@components/map/layers/targets/target.layer';
import { useContingencyBlinking } from '@hooks/useContingencyBlinking';
import { useSelectorWithMapId } from '@hooks/useSelectorWithMapId';
import { selectSelectedSensorFeatures } from '@redux/situation/monitoring.selectors';
import { selectSelectedExpiredDroneFeatures, selectSelectedTargetFeatures } from '@redux/situation/situation.selectors';
import { FeatureCollection } from 'geojson';
import { Layer, Source } from 'react-map-gl/mapbox';

import { FeatureTypeEnum, LayerNameEnum, SourceNameEnum } from '@/types/map.types';

import {
  engagedSelectedCircleLayer,
  engagedSelectedTargetBlinkingLayer,
  engagedSelectedTargetLayer,
} from './engagement/engagement.layer';

function SelectionLayer() {
  const selectedTargetFeatures = useSelectorWithMapId(selectSelectedTargetFeatures);
  const selectedExpiredDroneFeatures = useSelectorWithMapId(selectSelectedExpiredDroneFeatures);
  const selectedSensorFeatures = useSelectorWithMapId(selectSelectedSensorFeatures);

  const selectedFeatures: FeatureCollection = {
    type: 'FeatureCollection',
    features: [...selectedTargetFeatures, ...selectedExpiredDroneFeatures, ...selectedSensorFeatures],
  };

  useContingencyBlinking({
    sourceName: SourceNameEnum.SELECTION,
    layerNames: [
      LayerNameEnum.TARGET_SELECTION,
      LayerNameEnum.TARGET_SELECTION_CONTINGENCY,
      LayerNameEnum.ENGAGED_TARGET_SELECTION,
      LayerNameEnum.ENGAGED_TARGET_SELECTION_CONTINGENCY,
    ],
    featureTypes: [FeatureTypeEnum.TARGET_ICON, FeatureTypeEnum.ENGAGED_TARGET_ICON],
  });

  return (
    <Source id={SourceNameEnum.SELECTION} type="geojson" data={selectedFeatures}>
      <Layer {...selectedSensorIconLayer} />
      <Layer {...selectedSensorIconLabelLayer} />
      <Layer {...expiredTargetTrajectory} />
      <Layer {...targetCrossLayer} />
      <Layer {...selectedTargetLayer} />
      <Layer {...selectedTargetBlinkingLayer} />
      <Layer {...engagedSelectedCircleLayer} />
      <Layer {...engagedSelectedTargetLayer} />
      <Layer {...engagedSelectedTargetBlinkingLayer} />
    </Source>
  );
}

export default SelectionLayer;
